import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export function useAIGenerationEnabled() {
  const [isEnabled, setIsEnabled] = useState(true);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    checkStatus();
    const interval = setInterval(checkStatus, 30000);
    return () => clearInterval(interval);
  }, []);

  const checkStatus = async () => {
    try {
      const { data, error } = await supabase
        .from('system_config')
        .select('value')
        .eq('key', 'ai_generation_enabled')
        .maybeSingle();

      if (error) {
        console.error('Error checking AI generation status:', error);
        return;
      }

      setIsEnabled(data?.value === 'true');
    } catch (error) {
      console.error('Error checking AI generation status:', error);
    } finally {
      setLoading(false);
    }
  };

  return { isEnabled, loading };
}
